import { useI18n } from "../../utils/lni18n";
import { ImagePickerOverviewCoursePartDto } from "./ImagePicker_types";

const ImageInfoForPart = (props: { data: ImagePickerOverviewCoursePartDto }) => {


    const { languageService: t } = useI18n();
    const data = props.data

    return <div className="ms-4 mb-4">
        <h4 className="border-bottom">
            {data.Name}
        </h4>
        {data.Published && data.Published.Courses?.length > 0 && <div className="mb-3">
            <table className="table table-sm table-borderless">
                <thead >
                    <tr>
                        <th scope="col">{t.getText("courses")}</th>
                        <th scope="col">{t.getText("classes")}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Published.Courses.map((c, i) =>

                        <tr key={i}>
                            <td>
                                {c.Name}
                            </td>
                            <td>
                                {c.Classes && c.Classes.length > 0 && <>
                                    {c.Classes.map(cl => <div key={cl.Id} className="mb-2">{cl.Name}</div>)}
                                    </>
                                }
                                
                            </td>

                        </tr>)
                    }

                </tbody>
            </table>

            <ul>


            </ul>
        </div>
        }

    </div>

}

export default ImageInfoForPart;
